<template>
<div>
  <heading>Application Details</heading>
  <field label="CV*">
    <resume-upload-field :error="cvError" v-model="resume" :is-full-width="true" :uploading="uploading" />
  </field>
  <field label="Cover letter">
    <p class="control">
      <textarea class="textarea" placeholder="Cover letter"
        v-model="coverLetter">
      </textarea>
    </p>
  </field>
  <checkbox :value="optIn" :changeHandler="optInChangeHandler" :label="optInLabel"></checkbox>
</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import Divider from '@/components/general/divider'
import ResumeUploadField from '../jobseekers/resume-upload-field'
import Heading from '@/components/general/heading'
import Field from '@/components/general/field'
import Checkbox from '../general/checkbox.vue'

export default {
  props: {
    cvError: ['cvError']
  },
  components: { Divider, ResumeUploadField, Heading, Field, Checkbox },
  data () {
    return {
      uploading: false,
      optIn: true
    }
  },
  methods: {
    ...mapMutations('applicationForm', [
      'setCoverLetter',
      'setOptIn'
    ]),
    ...mapActions('jobseekerProfiles', [
      'uploadJobseekerResume'
    ]),
    optInChangeHandler (value) {
      this.optIn = value
      this.$store.commit('applicationForm/setSignupBoard', value)
    },
    async uploadResume (file) {
      if (file) {
        this.uploading = true
        await this.uploadJobseekerResume(file)
        this.uploading = false
      }
    }
  },
  computed: {
    ...mapState('applicationForm', {
      formCoverLetter: 'coverLetter',
      formSignupBoard: 'signupBoard'
    }),
    ...mapState('jobseekerForm', {
      formResume: 'resume'
    }),
    optInLabel () {
      return this.$t('jobs.iWantToBe')
    },
    coverLetter: {
      get () { return this.formCoverLetter },
      set (value) { this.setCoverLetter(value) }
    },
    resume: {
      get () { return this.formResume },
      set (value) { this.uploadResume(value) }
    }
  }
}
</script>

<style lang="scss" scoped>
.heading {
  margin-bottom: 1.5rem !important;
}

.field.is-spaced {
  display: flex;
  justify-content: space-between;
}
.is-right {
  float: right;
  color: #888;
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/apply-form.vue